import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API, useAuth } from "../App";
import { Crown, X } from "lucide-react";

const DISMISS_KEY = "petbond_sub_banner_dismissed_until";

export default function SubscriptionBanner() {
  const { user } = useAuth();
  const [sub, setSub] = useState({ parent: null, vendor: null });
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!user) return;
    try {
      const until = Number(localStorage.getItem(DISMISS_KEY) || 0);
      if (until && Date.now() < until) setDismissed(true);
    } catch {}
    axios.get(`${API}/billing/my-subscription`).then(r => setSub(r.data)).catch(() => {});
  }, [user]);

  if (!user || dismissed) return null;
  const isVendor = ["vet", "store_owner", "hostel_owner", "ngo"].includes(user.role);
  const active = isVendor ? (sub.vendor || sub.parent) : sub.parent;

  let state = null; // expiring | expired | none
  let daysLeft = null;
  if (active && active.expires_at) {
    daysLeft = Math.ceil((new Date(active.expires_at) - new Date()) / 86400000);
    if (daysLeft < 0) state = "expired";
    else if (daysLeft <= 7) state = "expiring";
  } else if (!active) {
    state = "none";
  }
  if (!state) return null;

  const dismiss = () => {
    try { localStorage.setItem(DISMISS_KEY, String(Date.now() + 24 * 3600 * 1000)); } catch {}
    setDismissed(true);
  };

  const messages = {
    expired: { color: "bg-danger text-white", title: "Your plan has expired", body: "Renew to restore premium features." },
    expiring: { color: "bg-sunshine/40 text-ink", title: `${daysLeft} day${daysLeft === 1 ? "" : "s"} left on your plan`, body: "Renew now to avoid interruption." },
    none: { color: "bg-brand/10 text-ink", title: "Unlock PetBond Premium", body: "Get 24/7 AI vet, unlimited Rx history & priority booking." },
  };
  const m = messages[state];

  return (
    <div className={`${m.color} rounded-2xl px-4 py-3 flex items-center gap-3 shadow-soft`} data-testid={`sub-banner-${state}`}>
      <Crown className="w-5 h-5 shrink-0"/>
      <div className="flex-1 min-w-0">
        <div className="font-bold text-sm">{m.title}</div>
        <div className="text-xs opacity-90 truncate">{m.body}</div>
      </div>
      <Link to="/app/billing" className="bg-ink text-white rounded-full px-4 py-1.5 text-xs font-bold whitespace-nowrap hover:opacity-90" data-testid="sub-banner-cta">
        {state === "none" ? "See plans" : "Renew"}
      </Link>
      <button onClick={dismiss} className="p-1 rounded-full hover:bg-black/10" data-testid="sub-banner-dismiss"><X className="w-4 h-4"/></button>
    </div>
  );
}
